import * as Sentry from '@sentry/browser'
import { Link } from 'router'
import { openModal } from 'modals'
import { buttonMessages } from 'components/inputs'

import messages from './messages'


type ErrorModalProps = {
  message: string | Intl.Message
}

export const openErrorModal = (props: ErrorModalProps) => {
  const message = props.message

  const closeModal = openModal('commonModal', {
    title: messages.userError.title,
    text: message,
    primaryButton: {
      title: buttonMessages.ok,
      onClick: () => {
        closeModal()
      },
    },
    'data-testid': 'errorModal',
  })
}

export const openFraudModal = () => openModal('fraudModal')

export const openNetworkErrorModal = () => {
  const closeModal = openModal('commonModal', {
    title: messages.networkError.title,
    text: {
      ...messages.networkError.text, components: { Link },
    },
    primaryButton: {
      title: buttonMessages.ok,
      onClick: () => {
        closeModal()
      },
    },
    'data-testid': 'errorModal',
  })
}

export const openServerErrorModal = () => {
  const lastEventId = Sentry.lastEventId()

  const closeModal = openModal('commonModal', {
    title: messages.serverError.title,
    text: {
      ...messages.serverError.text, components: { Link },
    },
    children: Boolean(lastEventId) && (
      <div className="text-p4 text-gray-50">
        Sentry ID: <a href={`https://sentry.scentbird.com/organizations/scentbird/issues/?query=${lastEventId}`}>{lastEventId}</a>
      </div>
    ),
    primaryButton: {
      title: buttonMessages.ok,
      onClick: () => {
        closeModal()
      },
    },
    'data-testid': 'errorModal',
  })
}

export const openChangePlanErrorModal = (action?: 'downgrade' | 'upgrade') => {
  let title

  if (action === 'downgrade') {
    title = messages.changePlanError.titleDowngrade
  }
  else if (action === 'upgrade') {
    title = messages.changePlanError.titleUpgrade
  }
  else {
    title = messages.changePlanError.titleDefault
  }

  const closeModal = openModal('commonModal', {
    title,
    text: {
      ...messages.changePlanError.text, components: { Link },
    },
    primaryButton: {
      title: buttonMessages.gotIt,
      onClick: () => {
        closeModal()
      },
    },
    'data-testid': 'errorModal',
  })
}
